import React from 'react';
import Button from '../../../common/Button/Button';
import { Link } from 'react-router-dom';

const ContentStep1B2b = () => {
  return (
    <div className="registration-content">
      <span className="registration-content__title">Газ та електроенергія для бізнесу</span>
      <span className="registration-content__sub-title">
        Зареєструйтесь або увійдіть, щоб відчути всі переваги особистого кабінету для вашого бізнесу
      </span>
      <div className="reg-content-buttons">
        <Link to="/b2b/sign-up">
          <Button type="primary" text="Зареєструватись" />
        </Link>
        <Link to="/sign-in">
          <Button type="outline-primary" text="Увійти" />
        </Link>
      </div>
    </div>
  );
};

export default ContentStep1B2b;
